// extracted by mini-css-extract-plugin
module.exports = {"h2":"TabAllArtworks_h2__SPCos","text":"TabAllArtworks_text__7gTYI","panelGachaMinting":"TabAllArtworks_panelGachaMinting__Evun1","divider":"TabAllArtworks_divider__XlVq6"};